<div class="max-w-7xl mx-auto p-4 sm:p-6 space-y-4 ">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h2 class="text-lg font-semibold text-slate-800">CFI Module</h2>
    </div>

    <!-- <div class="inline-flex rounded-xl border border-slate-200 bg-slate-50 text-xs shadow-sm p-1 px-2" role="tablist">
      <span
        *ngFor="let tab of tabs"
        role="tab"
        tabindex="0"
        class="px-3 py-2 font-medium transition-colors rounded-lg cursor-pointer select-none"
        [class.bg-blue-950]="activeTab === tab.key"
        [class.text-white]="activeTab === tab.key"
        [class.text-slate-500]="activeTab !== tab.key"
        (click)="setTab(tab.key)"
        (keyup.enter)="setTab(tab.key)"
        [attr.aria-pressed]="activeTab === tab.key"
      >
        {{ tab.label }}
      </span>
    </div> -->
  </div>

  <div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-5 items-end">
    <label class="flex flex-col gap-1 text-xs font-medium text-slate-600">
      Search/ create
      <input pInputText type="text" (click)="showSearchPopup = true" #searchInput
        placeholder="Search by title, owner, or ID"
        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-inner focus:border-slate-400 focus:outline-none" />
    </label>

    <label class="flex flex-col gap-1 text-xs font-medium text-slate-600">
      Status
      <select [(ngModel)]="statusFilter"
        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-inner focus:border-slate-400 focus:outline-none">
        <option value="all">All</option>
        <option value="Pending">Pending</option>
        <option value="In Progress">In Progress</option>
        <option value="Completed">Completed</option>
      </select>
    </label>

    <label class="flex flex-col gap-1 text-xs font-medium text-slate-600">
      Start date & time
      <input type="datetime-local" [(ngModel)]="startDate"
        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-inner focus:border-slate-400 focus:outline-none" />
    </label>

    <label class="flex flex-col gap-1 text-xs font-medium text-slate-600">
      End date & time
      <input type="datetime-local" [(ngModel)]="endDate"
        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 shadow-inner focus:border-slate-400 focus:outline-none" />
    </label>

    <div class="flex justify-end sm:justify-start lg:justify-end">
      <button type="button" (click)="resetFilters()" label="Reset"
        class="inline-flex items-center gap-2 rounded border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow hover:bg-slate-50 focus:outline-none">
        <i class="pi pi-refresh h-4 w-4"></i>
        Reset
      </button>
      <button type="button" (click)="onSearchChange(searchTerm)" label="Fetch"
        class="ml-2 inline-flex items-center gap-2 rounded border border-slate-200 bg-blue-100 px-4 py-2 text-sm font-semibold text-blue-700 shadow hover:bg-blue-200 focus:outline-none">
        <i class="pi pi-search h-4 w-4"></i>
        Fetch
      </button>
    </div>
  </div>

  <div class="overflow-hidden border-2 border-slate-200 bg-white shadow-sm p-2">
    <p-table [value]="cfiRows" [paginator]="cfiRows.length > 9" [rows]="10" class="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns">
            <div class=" flex items-center gap-2">
              <p-sortIcon [field]="col.field" [pSortableColumn]="col.field" styleClass="custom-sort-icon"></p-sortIcon>
              <span class="column-title">{{ col.header.toUpperCase() }}</span>
              <p-columnFilter class="text-gray-600" type="text" [showAddButton]="false" [field]="col.field"
                display="menu" />

            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr (click)="updateCfi(row)" class="cursor-pointer text-blue-600 hover:text-blue-800 font-medium">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'created_on'">
                <span class="text-gray-600 font-mono">
                  {{ row[col.field] | date:'dd MMM yy' }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'file_status'">
                <span class="inline-block px-3 py-1 rounded-full text-xs font-semibold border" [ngClass]="{
                    'bg-green-100 text-green-700 border-green-300': row[col.field]?.toLowerCase() === 'approved' || row[col.field]?.toLowerCase() === 'active',
                    'bg-yellow-100 text-yellow-700 border-yellow-300': row[col.field]?.toLowerCase() === 'pending' || row[col.field]?.toLowerCase() === 'in-progress',
                    'bg-gray-100 text-gray-700 border-gray-300': !row[col.field] || 
                      (row[col.field]?.toLowerCase() !== 'approved' && row[col.field]?.toLowerCase() !== 'pending' && row[col.field]?.toLowerCase() !== 'active' && row[col.field]?.toLowerCase() !== 'in-progress'),
                    'bg-red-100 text-red-700 border-red-300': row[col.field]?.toLowerCase() === 'rejected' || row[col.field]?.toLowerCase() === 'inactive'
                  }">
                  {{ row[col.field] || 'N/A' }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'indent_no'">
                <span class="text-blue-600 hover:text-blue-800 font-medium">
                  {{ row[col.field] | uppercase }}
                </span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ row[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length + 1">
            No CFI records found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- Popup Overlay -->
<div *ngIf="showSearchPopup"
  class="fixed inset-0 z-50 flex items-center justify-center bg-white/70  mx-auto bg-opacity-40"
  (click)="showSearchPopup = false">
  <!-- Stop click propagation to overlay background -->
  <div
    class="bg-white rounded shadow-lg max-w-7xl mx-auto w-full min-h-[80vh] max-h-[90vh] p-6 relative overflow-y-auto"
    (click)="$event.stopPropagation()">
    <button type="button" class="absolute right-3 top-3 text-slate-500 hover:text-red-600 text-xl"
      (click)="showSearchPopup = false" aria-label="Close popup">×</button>
    <h2 class="text-lg font-bold mb-4 text-slate-700">CFI Search</h2>
    <div class="w-3/4 mx-auto">
      <input #searchInput type="text" placeholder="Type to search..."
        class="w-full rounded border border-slate-300 px-1 py-1 text-sm text-slate-800 focus:border-blue-500 focus:outline-none mb-4"
        autofocus (keyup.enter)="onSearchChange(searchInput.value)" />
      <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm overflow-y-auto max-h-[380px]">
        <ul class="divide-y divide-slate-100">
         <li *ngIf="result.length === 0"
  (click)="showSearchPopup = false; showDialog = true; $event.stopPropagation()"
  class="bg-blue-100 p-2 m-2 rounded">
  + Add New CFI Requision
</li>
          <ng-container *ngFor="let row of result">
            <li (click)="selectCfi(row); $event.stopPropagation()"
              class="py-3 px-2 hover:bg-slate-50 rounded transition flex flex-col sm:flex-row sm:items-center sm:justify-between cursor-pointer">
              <div>
                <div class="font-semibold text-blue-700 text-base">{{ row.indent_no | uppercase }}</div>
                <div class="text-xs text-slate-500 mt-0.5">Created by: {{ row.user_created }} • {{ row.created_on |
                  date:'dd MMM yy' }}</div>
              </div>
              <!-- <div class="flex flex-col sm:flex-row sm:items-center sm:space-x-6 mt-2 sm:mt-0">
                <span class="text-xs mr-4">
                  <span class="font-semibold text-slate-600">Status:</span>
                  <span class="font-medium ml-1" [ngClass]="{
                  'text-green-600': row.file_status?.toLowerCase() === 'approved' || row.file_status?.toLowerCase() === 'active',
                  'text-yellow-600': row.file_status?.toLowerCase() === 'pending' || row.file_status?.toLowerCase() === 'in-progress',
                  'text-red-600': row.file_status?.toLowerCase() === 'rejected' || row.file_status?.toLowerCase() === 'inactive'
                }">{{ row.file_status || 'N/A' }}</span>
                </span>
                <span class="text-xs" *ngIf="row.remark">
                  <span class="font-semibold text-slate-600">Remark:</span>
                  <span class="ml-1">{{ row.remark }}</span>
                </span>
              </div> -->
            </li>
          </ng-container>
          <li *ngIf="result.length === 0" class="py-10 text-center text-slate-400 text-sm">
            No results found. Type and press enter to search.
          </li>
        </ul>
      </div>
    </div>

  </div>
</div>

<p-dialog header="CFI Details" [(visible)]="showDialog" [modal]="true" [style]="{width: '60vw'}" [closable]="true"
  [dismissableMask]="true">
  <ng-template pTemplate="content">
    <div class="flex justify-end mt-2">
      <button type="button" class="px-3 py-1.5 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition"
        (click)="downloadCSV()" title="Download CSV">
        <i class="pi pi-download mr-1 text-blue-700"></i> Sample CSV
      </button>
    </div>
    <form [formGroup]="createForm" class="w-full px-4 pb-2">
      <div class="grid grid-cols-1 gap-4">
        <!-- Indent No. and Attachment in one row for md and up, stacked for small screens -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Indent No. -->
          <div>
            <label class="block font-semibold text-sm text-blue-600 mb-1" for="indent_no">Indent No.:</label>
            <input type="text" id="indent_no" formControlName="indent_no"
              class="w-full border-2 border-slate-200 px-2 py-2.5 text-sm" />
          </div>
          <!-- Attachment -->
          <div>
            <label class="block font-semibold text-sm text-blue-600 mb-1" for="fileInput">Attachment (.csv or .xlsx or
              .xls):</label>
            <input type="file" (change)="onFileChange($event)" id="fileInput" accept=".csv,.xlsx,.xls"
              class="w-full border-2 border-slate-200 px-2 py-2 text-sm" />
          </div>
        </div>
        <!-- Remarks full width, textarea -->
        <div>
          <label class="block font-semibold text-sm text-blue-600 mb-1" for="remarks">Remarks:</label>
          <textarea id="remark" formControlName="remark" rows="4"
            class="w-full border-2 border-slate-200 px-2 py-2.5 text-sm resize-y"
            placeholder="Enter remarks here"></textarea>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" class="px-4 py-2 mr-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition"
      (click)="showDialog=false">
      Close
    </button>
    <button type="submit" (click)="submitForm()"
      class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
      Save
    </button>
  </ng-template>
</p-dialog>

<p-toast />

<ng-container *ngIf="displayDialog">
  <app-scheme-wise-route-popup [displayDialog]="displayDialog" (closeDialog)="displayDialog = false"
    (onSubmit)="onNeedformSubmit($event)"></app-scheme-wise-route-popup>
</ng-container>

<!-- Popup Dialog for Reusable Table -->
<p-dialog header="CFI List" [(visible)]="cfiListPopup" [modal]="true" [closable]="true" [style]="{width: '90vw'}"
  (onHide)="cfiListPopup = false">
  <ng-template pTemplate="content">
    <div class="py-3">
      <app-data-table [data]="cfiListTableData" [columns]="cfiListColumns" [title]="'Item CFI List'"
        [showHeader]="false" [showAddButton]="false" [showActions]="false" [showSearch]="false">
      </app-data-table>

    </div>
  </ng-template>
</p-dialog>